import { render } from "./ViewsErrorsCode.vue?vue&type=template&id=3a7caf9e"
import script from "./ViewsErrorsCode.vue?vue&type=script&lang=js"
export * from "./ViewsErrorsCode.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__